import React from 'react';
import VisitorAppointment from '../components/visitor/VisitorAppointment/visitorAppointment';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';


function CreateAppointment() {
    const canCreateAppointment = hasPermission('Self-Guided Tours', 'Appointments', 'create');
    const navigate = useNavigate();
    // Selectors for appointment units

    if (!canCreateAppointment) {
        navigate('/no-permission');
    }

    return (
        <div className="outletConainer" style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        }}>
            <VisitorAppointment />
        </div>
    );
}

export default CreateAppointment;
